import { IconLogout, IconSettings } from '@tabler/icons-react';
import React from 'react';

export interface NavigationItem {
	icon: React.ComponentType<{ size?: number | string }>;
	label: string;
	description: string;
	path: string;
	badge?: string;
}

export const LEFT_COLUMN_ITEMS: NavigationItem[] = [];

export const RIGHT_COLUMN_ITEMS: NavigationItem[] = [
	{
		icon: IconSettings,
		label: 'Settings',
		description: 'Manage manufacturer settings',
		path: '/settings',
	},
];

export const LOGOUT_ITEM = {
	icon: IconLogout,
	label: 'Log out',
	description: '',
	isLogout: true,
};
